import Banner from './Banner';
import BannerTitle from './BannerTitle';
import BannerSubtitle from './BannerSubtitle';
import PillarNumberBadge from './PillarNumberBadge';

export type { BannerProps } from './Banner';
export type { BannerTitleProps } from './BannerTitle';
export type { BannerSubtitleProps } from './BannerSubtitle';
export type { PillarNumberBadgeProps } from './PillarNumberBadge';

export default Banner;
export { BannerTitle, BannerSubtitle, PillarNumberBadge };
